import * as errorHandler from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import { SET_LIST_PREFERRED_CHANNEL, PROCESSING } from './types';
const { allBillerApiService } = apiService.getInstance();

// Setter Payload Data
export const setChannelList = data => ({
  type: SET_LIST_PREFERRED_CHANNEL,
  payload: data,
});

export const getChannelList = () => async dispatch => {
  // Set Activity To Proccess
  dispatch({ type: PROCESSING });
  // Do Load Data Channel List
  try {
    const response = await allBillerApiService.get('channel');
    if (response.status === 200) {
      const { payload } = response.data;
      const data = payload.map(channel => channel.id);

      dispatch(channels.setChannelList(data));
    } else {
      errorHandler.errorHandle(response);
      dispatch(channels.setChannelList([]));
    }
  } catch (error) {
    errorHandler.errorHandle(error);
    dispatch(channels.setChannelList([]));
  }
};

const channels = {
  setChannelList,
  getChannelList,
};

export default channels;
